(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {}; this.currentScrollTop = 0; this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    createObserver() {
      let o = new IntersectionObserver((e, o) => { this.headerBounds = e[0].intersectionRect; o.disconnect(); });
      o.observe(this);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    reveal() { this.classList.add('animate','header-wrapper--border-bottom'); this.classList.remove('shopify-section-header-hidden'); }
    hide() { if (this.headerIsAlwaysSticky) return; this.classList.add('shopify-section-header-hidden','animate','header-wrapper--border-bottom'); }
    onScroll() {
      const s = window.pageYOffset || document.documentElement.scrollTop;
      if (Math.abs(s - this.currentScrollTop) < 50) return;
      if (s > this.currentScrollTop && s > this.headerBounds.bottom) { this.hide(); }
      else if (s < this.currentScrollTop && s > this.headerBounds.bottom) {
        if (this.preventReveal) { window.clearTimeout(this.isScrolling); this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66); return; }
        this.reveal();
      } else if (s <= this.headerBounds.top) { this.reveal(); }
      this.currentScrollTop = s;
    }
  }
  customElements.define('sticky-header', StickyHeader);
  // Búsqueda por imagen
  window.mnImgSearch = function(input) {
    const file = input.files[0];
    if (!file) return;
    const r = new FileReader();
    r.onload = function(e) { sessionStorage.setItem('mn_img', e.target.result); window.location.href = '/search?type=product&q='; };
    r.readAsDataURL(file);
    input.value = '';
  };

  } catch(e) { console.error(e); }
})();
})();
